<template>
    <div class="mQuesbanklist">
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!item.qbanklist.length"></NoData>
            <div class="quesbanklist m-list" v-else>
                <div class="course box" v-for="(obj) in item.qbanklist" :key="obj.courseid" @click="gotoBank(obj)">
                    <img class="coverurl" :src="obj.coverurl" alt="">
                    <div class="subject">{{obj.subject}}</div>
                    <div class="price">
                        <span class="tc-blue" v-if="obj.feettype == 1">免费</span>
                        <div v-else class="price-box">
                            <span class="saleprice tc-red">￥{{obj.saleprice}}</span>
                            <!--<span class="uprice tc-grey" v-if="obj.uprice && !obj.islimitcount">￥{{obj.uprice}}</span>-->
                            <span class="limit-label" v-if="obj.islimitcount">限时折扣</span>
                        </div>
                    </div>
                </div>
            </div>
        </Pull>
    </div>
</template>

<script>
    import Pull from 'views/mobile/components/pull/pull'
    import {getAllQuestionbankByHost} from 'api/questionbank'
    import {mapActions, mapGetters} from 'vuex'
    import NoData from 'views/mobile/components/noData/noData'
    export default {
        name: 'mBankList',
        data() {
            return {
                param: {
                    hostid: this.$route.query.hostid ? this.$route.query.hostid : '',
                    // teacherid: this.$route.query.teacherid ? this.$route.query.teacherid : ''
                },
                page: {
                    page: 1,
                    pagesize: 10,
                    pageCount: 2,
                    rowCount: 0
                },
                pull: {
                    isLoading: false,
                    loading: false,
                    error: false,
                    finished: false
                },
            }
        },
        props: ['item'],
        mounted() {
        },
        activated() {
            if (this.refresh) {
                this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
                // this.param.teacherid = this.$route.query.teacherid ? this.$route.query.teacherid : ''
            }
        },
        methods: {
            gotoBank(obj) {
                this.$router.push({name: 'PaperDetails', query: {'qid': obj.bankid}});
                this.setRefresh(true)
            },
            getList() {
                this.setLoading(true)
                getAllQuestionbankByHost({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        if (this.page.page === 1) {
                            this.pull.isLoading = false
                            this.item.qbanklist = data.data.quesbanklist
                        } else {
                            this.item.qbanklist = this.item.qbanklist.concat(data.data.quesbanklist)
                        }
                        this.setLoading(false)
                        this.pull.loading = false
                        this.page.pageCount = data.data.pageinfo.pageCount
                        this.page.rowCount = data.data.pageinfo.rowCount
                        if (this.page.page === this.page.pageCount) {
                            this.pull.finished = true
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.pull.error = true
                        this.pull.loading = false
                        this.$toast.fail(data.msg)
                    }
                })
            },
            ...mapActions(['setLoading', 'setRefresh'])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters(['refresh'])
        },
        components: {
            Pull, NoData
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .mQuesbanklist {
        .quesbanklist{
            background: $c-white;
        }
    }
</style>